import { Directive, HostBinding, Input, OnInit } from "@angular/core";

@Directive()

export class BaseComponent implements OnInit {

    @Input() infoText: string;
    @Input() required?: boolean;
    @Input() disabled?: any;
    @Input() label: string;
    @Input() aid: string;

    @HostBinding("attr.required") get getRequiredState() { return (this.required ? "" : null);}

    // eslint-disable-next-line sonarjs/public-static-readonly
    static idTick = 0;

    parseAttributes() {
        this.required = this.emptyIsTrue(this.required);
        this.disabled = this.emptyIsTrue(this.disabled);
    }

    emptyIsTrue = (val) => {
        if (val === "") {
            return true;
        } else if (val === undefined) {
            return false;
        }
        return val;
    };

    ngOnInit() {
        this.parseAttributes();
        this.parseAid();
    }

    parseAid() {
        if (this.aid) {
            return;
        }
        this.aid = `${BaseComponent.idTick}+_aid;`;
        BaseComponent.idTick++;
    }

}
